<div
     snAssistantSurface="secret"
     i18n-surfaceTitle="@@secret.surface"
     surfaceTitle="Secret" class="secret-edit-container">
  @if (isLoading) {
    <div class="loading-container">
      <p-progressSpinner />
      <p>Loading secret...</p>
    </div>
  } @else {
    <!-- Header -->
    <div class="header">
      <div class="header-left">
        <h1>{{ isNew ? 'Create Secret' : 'Edit Secret' }}</h1>
        @if (!isNew && secret) {
          <p class="secret-id">{{ secret.id }}</p>
        }
      </div>
      @if (!isNew) {
        <p-button
          icon="pi pi-trash"
          severity="danger"
          [outlined]="true"
          (click)="deleteSecret()"
          snAssistantAction="delete"
          actionDangerous
          actionHint="Deletes the secret. Anything referencing it — tools, telephony — starts failing authentication."
          pTooltip="Delete secret"
          tooltipPosition="bottom"
          [disabled]="isSaving">
        </p-button>
      }
    </div>

    <!-- Form -->
    <div class="form-container">
      <div class="form-field">
        <label for="secretName" class="field-label">Name</label>
        <p class="field-description">A unique name for this secret.</p>
        <input
          [snAssistantId]="F.secretName"
          pInputText
          id="secretName"
          [(ngModel)]="name"
          placeholder="Enter secret name"
          class="w-full"
          [disabled]="isSaving">
      </div>

      <div class="form-field">
        <label for="secretValue" class="field-label">Value</label>
        <p class="field-description">The secret value. This will be stored securely.</p>
        <textarea
          [snAssistantId]="F.secretValue"
          pTextarea
          id="secretValue"
          [autoResize]="true"
          [(ngModel)]="value"
          placeholder="Enter secret value"
          class="w-full"
          [disabled]="isSaving">
        </textarea>
      </div>
    </div>
  }
</div>

<!-- Desktop Action Buttons (outside container for sticky positioning) -->
@if (!isLoading) {
  <div
       class="action-buttons"
       snAssistantSurface="secret"
       i18n-surfaceTitle="@@secret.surface"
       surfaceTitle="Secret">
    <p-button
      type="button"
      label="Back"
      severity="secondary"
      [outlined]="true"
      (click)="goBack()"
      icon="pi pi-arrow-left"
      [disabled]="isSaving">
    </p-button>
    <p-button
      type="button"
      [label]="isSaving ? 'Saving...' : (isNew ? 'Create Secret' : 'Save Changes')"
      snAssistantAction="save"
      actionHint="Saves the secret."
      (click)="save()"
      [icon]="isSaving ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
      [disabled]="isSaving || !name || !value"
      [loading]="isSaving">
    </p-button>
  </div>
}

<!-- Mobile Bottom Toolbar -->
@if (!isLoading) {
  <p-toolbar class="mobile-bottom-toolbar">
    <ng-template pTemplate="start">
      <p-button
        type="button"
        label="Back"
        severity="secondary"
        [outlined]="true"
        (click)="goBack()"
        icon="pi pi-arrow-left"
        size="small"
        [disabled]="isSaving">
      </p-button>
    </ng-template>

    <ng-template pTemplate="end">
      <p-button
        type="button"
        [label]="isSaving ? 'Saving...' : (isNew ? 'Create Secret' : 'Save Changes')"
        (click)="save()"
        [icon]="isSaving ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
        [disabled]="isSaving || !name || !value"
        [loading]="isSaving"
        size="small">
      </p-button>
    </ng-template>
  </p-toolbar>
}

<!-- Delete Confirmation Dialog -->
<app-delete-confirmation
  [(visible)]="deleteDialogVisible"
  [title]="'Delete Secret'"
  [subtitle]="'Are you sure you want to delete secret &quot;' + name + '&quot;? This action cannot be undone.'"
  [deleting]="isDeleting"
  (confirm)="onDeleteConfirm()"
  (cancel)="onDeleteCancel()" />
